import type { DatabaseView } from '@databases/types/database/view';

/**
 * Combines persisted view names with any pending (unsaved) renames
 * for use in uniqueness checks when creating or duplicating views.
 */
export const getAllViewNames = (
  savedViews: DatabaseView[],
  pendingViewNames: Record<string, string>
): string[] => [...savedViews.map((v) => v.name), ...Object.values(pendingViewNames)];
